import { useInView } from 'motion/react';
import { useRef } from 'react';

import { AnimatedWords } from './animated-words';

import { cn } from '~/lib/utils';

interface ProductMainPhraseSectionProps {
  text: string;
  className?: string;
  textClassName?: string;
}

export const ProductMainPhraseSection = ({
  text,
  className,
  textClassName,
}: ProductMainPhraseSectionProps) => {
  const containerRef = useRef<HTMLParagraphElement>(null);
  const isInView = useInView(containerRef, { once: true, amount: 0.3 });

  return (
    <section className={cn('bg-black px-4 md:px-20 py-[120px] md:py-[200px]', className)}>
      <p ref={containerRef} className={cn(
        'text-center text-white max-w-[1320px] mx-auto font-manrope text-[40px] md:text-[96px] font-normal leading-[1.2]',
        textClassName
      )}>
        <AnimatedWords
          text={text}
          as="span"
          isInView={isInView}
          wordClassName="will-change-transform"
          initial={{ y: '40%', opacity: 0 }}
          animate={{ y: '0%', opacity: 1 }}
          transition={{
            duration: 0.8,
            ease: [0.25, 0.1, 0.25, 1],
            opacity: {
              duration: 1.2,
              ease: [0.4, 0, 0.2, 1],
            },
          }}
          delayStep={0.03}
        />
      </p>
    </section>
  );
};
